import { inject, Injectable, makeStateKey, signal, TransferState } from '@angular/core';

import { ENVIRONMENT } from '@environment';

type HeaderDisplayStyle = 'block' | 'none';

export const HEADER_DISPLAY_STYLE = makeStateKey<HeaderDisplayStyle>('HEADER_DISPLAY_STYLE');
@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private readonly env = inject(ENVIRONMENT);
  private readonly transferState = inject(TransferState);

  private readonly ssrHeaderStatus = this.transferState.get<HeaderDisplayStyle>(HEADER_DISPLAY_STYLE, 'block');
  displayStyle = signal<'block' | 'none'>(this.env?.appHasOnlyMovies ? 'none' : this.ssrHeaderStatus);

  // Method to update the signal whenever you want to change the style
  setDisplayStyle(style: 'block' | 'none') {
    this.transferState.set<HeaderDisplayStyle>(HEADER_DISPLAY_STYLE, style);
    this.displayStyle.set(style);
  }
}
